// extracted by mini-css-extract-plugin
export default {"wrapper":"projectCard_wrapper__dYozT","projectCard":"projectCard_projectCard__4AAKX","description":"projectCard_description__pGS-c"};